"use strict";

angular.module("core")
.component("singleAction", {
    templateUrl: require("./single-action.component.html"),
    controller: SingleActionController,
    controllerAs: "singleActionCtrl",
    bindings: {
        service: "<",
        instanceId: "<",
        referenceId: "<?"
    }
});

function SingleActionController($rootScope, $scope, ModalService, ActionFactory, UserService) {
    var _this = this;
    var actionService = new ActionFactory(this.service);

    var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        updateActionParams();
    });

    this.$onDestroy = function() {
        unregisterLanguageChanged();
    };

    this.submit = function(action) {
        if ($scope.singleActionParams[action].method) {
            $scope.singleActionParams[action].method(this.instanceId);
        } else {
            actionService.submitSingleAction(action, this.instanceId, this.referenceId).then(function onSuccess() {
                $scope.$emit("queryListing");
            });
        }
    };

    function updateActionParams() {
        UserService.isUserFetched().then(function onSuccess(user) {
            $scope.singleActionParams = _this.service.getSingleActionParams(user);
        });
    }

    updateActionParams();
}



//////////////////
// WEBPACK FOOTER
// ./core/action/single-action.component.js
// module id = 586
// module chunks = 0